import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { getFixedDosage } from "../../utils/helper";
import { use } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
} from "../../actions/formulaAction";

const ServingsSection = ({
  isRawType,
  overallTotal,
  totalPacket,
  packetsPerDay,
  setPacketsPerDay,
  days,
  setDays,
  scoops,
  setScoops,
  timePerDay,
  setTimePerDay,
  rawGramPerDayBeforeConversion,
  prepMethod,
  requireServing,
  isConverted,
  setTotalPacket,
}) => {
  const dispatch = useDispatch();
  const [firstTime, setFirstTime] = useState(true);
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const prescriptionFormFields = useSelector(
    (state) => state.settings.prescriptionFormFields
  );
  useEffect(() => {
    if (!isRawType) {
      if (firstTime && scoops > 0) {
        //setScoops(prepMethod?.id == 5 ? scoops * 2 : scoops);
        setFirstTime(false);
      } else {
        setScoops(prepMethod?.id == 5 ? scoops * 2 : scoops / 2);
        setScoops(
          Math.round(
            prepMethod?.id == 5
              ? scoops * (2 * prescriptionFormFields.scoopSize)
              : scoops / (2 * prescriptionFormFields.scoopSize)
          )
        );
      }
    }
  }, [prepMethod]);

  useEffect(() => {
    if (isRawType) {
      setFirstTime(true);
    }
  }, [isRawType]);

  useEffect(() => {
    if (packetsPerDay > 0 && days > 0) {
      setTotalPacket(packetsPerDay * days);
    }
  }, [packetsPerDay, days]);
  const getDosageToChange = (desiredGranularTotal) => {
    let existingGranularTotal = 0;
    // Calculate existing granular total from formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from formula herbs
      });
    });

    // Calculate existing granular total from single herbs
    singleHerbList.forEach((herb) => {
      existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from single herbs
    });

    // Calculate additional granular needed
    let additionalGranularNeeded =
      desiredGranularTotal - getFixedDosage(existingGranularTotal);

    // Calculate total raw amount needed based on ratios
    let totalRawNeeded = 0;

    // Calculate raw amounts for formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        let rawAmount =
          (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1;
        rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
        totalRawNeeded +=
          (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
      });
    });

    // Calculate raw amounts for single herbs
    singleHerbList.forEach((herb) => {
      let rawAmount =
        (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1;
      rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
      totalRawNeeded +=
        (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
    });

    // Add existing raw amounts to total needed
    const totalExistingRawAmount =
      formulas.reduce((total, formula) => {
        return (
          total +
          formula.formulaHerbs.reduce(
            (sum, herb) =>
              sum +
              (isNaN(
                (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ??
                  1
              )
                ? 0
                : (herb.dosageInFloat * herb.rawRatio ?? 5) /
                    herb.granularUnit ?? 1),
            0
          )
        );
      }, 0) +
      singleHerbList.reduce(
        (total, herb) =>
          total +
          (isNaN(
            (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1
          )
            ? 0
            : (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ??
              1),
        0
      );

    return totalExistingRawAmount + totalRawNeeded;
  };

  useEffect(() => {
    if (!isRawType && isConverted) {
      dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
      dispatch(
        changeFormulaType(
          true,
          getDosageToChange(parseFloat(scoops * days * timePerDay)),
          null,
          true
        )
      );
      dispatch(changeFormulaTypeFromDays(false, 1));
    }
  }, [isRawType]);

  useEffect(() => {
    if (!isRawType && scoops >= 1 && days >= 1 && timePerDay >= 1) {
      dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
      dispatch(
        changeFormulaType(
          true,
          getDosageToChange(
            parseFloat(
              scoops *
                days *
                timePerDay *
                (prepMethod?.id == 5 ? 0.5 : prescriptionFormFields.scoopSize)
            )
          ),
          null,
          true
        )
      );
      dispatch(changeFormulaTypeFromDays(false, 1));
    }
  }, [scoops, days, timePerDay]);

  return (
    <div className="serving-section border">
      <h5 className="heading">Serving Instructions</h5>

      {isRawType ? (
        <div className="wrapper">
          <table className="table">
            <tbody>
              <tr>
                <th className="ml-1">Packet(s)/Day</th>
                <th></th>
                <th className="ml-1">Day(s)</th>
                <th></th>
                <th className="ml-1 text-center">Total Packet(s)</th>
                <th className="ml-1 text-center">Total Grams</th>
              </tr>
              <tr>
                <td className="number-field-wrapper">
                  <div className="number-field">
                    <select
                      className="packet-select"
                      value={parseFloat(packetsPerDay)}
                      onChange={(e) => setPacketsPerDay(e.target.value)}
                    >
                      {[0.5, 1, 2, 3, 4, 5].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                    {/* <div>
                      <div
                        className="icon"
                        onClick={() => setPacketsPerDay(packetsPerDay + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setPacketsPerDay(
                            packetsPerDay > 0 ? packetsPerDay - 1 : 0
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div> */}
                  </div>
                </td>
                <td className="text-center"></td>
                <td className="number-field-wrapper">
                  <div className="number-field ">
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={1}
                      value={days}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setDays(parseInt(e.target.value))
                          : setDays(0);
                      }}
                    />
                    <div>
                      <div className="icon" onClick={() => setDays(days + 1)}>
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() => setDays(days > 0 ? days - 1 : 0)}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="text-center"></td>

                <td className="text-center">
                  <b>{totalPacket}</b>
                </td>
                <td className="text-center">
                  {" "}
                  <b>{overallTotal.totalDosage * totalPacket}g</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="wrapper">
          <table className="table">
            <tbody>
              <tr>
                {/* <th>SERVINGS{requireServing ? "*" : ""}</th>
                <th></th> */}
                <th className="">
                  <label className="ml-1">Serving Size</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Frequency</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Duration</label>
                </th>
                <th></th>
                <th className="">
                  {" "}
                  <label className="ml-1">Daily Dosage</label>
                </th>
                <th className="">
                  {" "}
                  <label className="ml-1">Total Grams</label>
                </th>
              </tr>
              <tr>
                {/* <td className="number-field-wrapper" style={{ width: "130px" }}>
                  (1 scoop = 1 g)
                  <br />
                  (1 capsule = 0.5 g)
                </td>
                <td className="text-center">x</td> */}
                <td
                  className="number-field-wrapper"
                  style={{ position: "relative" }}
                >
                  <div
                    className={`number-field ${
                      scoops <= 0 && (days > 0 || timePerDay > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      value={parseFloat(scoops)}
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setScoops(parseInt(e.target.value))
                          : setScoops(1);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setScoops(parseInt(scoops) + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() => setScoops(scoops > 2 ? scoops - 1 : 1)}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                    <p
                      className="ml-1 mt-1"
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        position: "absolute",
                        top: "75%",
                      }}
                    >
                      {prepMethod?.id == 1
                        ? `(1 scoop = ${prescriptionFormFields?.scoopSize} grams)`
                        : prepMethod?.id == 5
                        ? "(1 capsule = 0.5 grams)"
                        : prepMethod?.id == 6
                        ? "Tablets"
                        : ""}
                    </p>
                  </div>
                  <p className="ml-1 mt-1">
                    {prepMethod?.id == 1
                      ? "Scoops"
                      : prepMethod?.id == 5
                      ? "Capsules"
                      : prepMethod?.id == 6
                      ? "Tablets"
                      : ""}
                  </p>
                </td>
                <td className="text-center"></td>
                <td className="number-field-wrapper">
                  <div
                    className={`number-field ${
                      timePerDay <= 0 && (days > 0 || scoops > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      value={parseInt(timePerDay)}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setTimePerDay(parseInt(e.target.value))
                          : setTimePerDay(1);
                      }}
                    />
                    <div>
                      <div
                        className="icon"
                        onClick={() => setTimePerDay(parseInt(timePerDay) + 1)}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() =>
                          setTimePerDay(timePerDay > 2 ? timePerDay - 1 : 1)
                        }
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                  <p className="ml-1 mt-1">Time(s) per day</p>
                </td>
                <td className="text-center"></td>
                <td className="number-field-wrapper">
                  <div
                    className={`number-field ${
                      days <= 0 && (timePerDay > 0 || scoops > 0)
                        ? "border border-warning"
                        : ""
                    } `}
                  >
                    <input
                      type="text"
                      pattern="[0-9]*"
                      min={0}
                      value={days}
                      onChange={(e) => {
                        parseInt(e.target.value) > 0
                          ? setDays(parseInt(e.target.value))
                          : setDays(1);
                      }}
                    />
                    <div>
                      <div className="icon" onClick={() => setDays(days + 1)}>
                        <FontAwesomeIcon icon={faCaretUp} />
                      </div>
                      <div
                        className="icon"
                        onClick={() => setDays(days > 2 ? days - 1 : 1)}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </div>
                    </div>
                  </div>
                  <p className="ml-1 mt-1">Day(s)</p>
                </td>
                <td className="text-center"></td>
                <td className="">
                  <b>
                    {(
                      scoops *
                      timePerDay *
                      (prepMethod?.id == 5
                        ? 0.5
                        : prescriptionFormFields?.scoopSize)
                    ).toFixed(1)}{" "}
                    grams
                  </b>
                </td>
                <td className="">
                  <b>{overallTotal.totalDosage} grams</b>
                </td>
              </tr>
            </tbody>
          </table>
          {rawGramPerDayBeforeConversion &&
          rawGramPerDayBeforeConversion != null ? (
            <p className="page-desc mt-3" style={{ marginBottom: 0 }}>
              Note: Daily Recommended Dosage:{" "}
              {getFixedDosage(rawGramPerDayBeforeConversion)}g (equivalent to 1
              packet of Raw herbs)
            </p>
          ) : (
            ""
          )}
          <p className="page-desc">
            Note: All fields must be filled in order for the serving
            instructions to be printed on the label.
          </p>
        </div>
      )}
    </div>
  );
};

export default ServingsSection;
